import React from "react";

import {connect} from "react-redux";
import {withRouter} from "react-router"; // further imports omitted
import {NavLink} from "react-router-dom";
import {Button, Nav, Row, Col, Modal, Popover, OverlayTrigger, Tooltip} from "react-bootstrap";
import {AlertTriangle} from "lucide-react";
import {updateDriverProperties, fetchDriverProperties, propertiesWorker, allErrorsRemove} from "../../../../actions";
import {noProperty, getErrorIssues, getWarningIssues} from "../../../../utils/validationSummary";
import {Trans, withTranslation} from "react-i18next";
import {X_API_KEY} from "../../../../utils/authentication";

class ProjectHeader extends React.Component {
    interval = null;

    constructor(props) {
        super(props);

        this.state = {
            queue: null,
            label: "",
            class: "saved-label",
            selectedKey: window.location.hash,
            disabled_download: this.props.disabled,
            openInP4Modal: null,
        };

        this.openP4 = this.openP4.bind(this);
        this.openInP4Url = this.openInP4Url.bind(this);

        // ----------------
        // START WEB WORKER
        // ----------------
        const self = this;
        propertiesWorker.addEventListener("message", async function (e) {
            if (!e.data.type) {
                const {projectId, driverId, driverProperties} = e.data;
                self.props.updateDriverProperties(projectId, driverId, driverProperties).then(() => {
                    if (driverProperties.filter((p) => p.info.name.startsWith("led")).length > 0) {
                        self.props.fetchDriverProperties(projectId, driverId);
                    }
                });
            } else {
                const queue = e.data.data;
                self.setState({queue: Object.keys(queue).length !== 0 ? queue : null});
            }
        });
        // ----------------
        // END WEB WORKER
        // ----------------

        this.onTick = this.onTick.bind(this);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    closeProject() {
        this.props.history.push("/");
    }

    componentDidMount() {
        this.interval = setInterval(this.onTick, 2000);
    }

    openInP4Url() {
        const protocol = window.location.protocol; // "http:" or "https:"
        const host = window.location.hostname; // "localhost", "dev.tuner4tronic.com", etc.
        const port = window.location.port; // e.g. "3000", or "" if default

        // Combine full origin including port (only if port is set)
        const fullOrigin = port ? `${protocol}//${host}:${port}` : `${protocol}//${host}`;

        const param3 = fullOrigin;
        const param2 = this.props.project?.id || "unknown";
        const param1 = "-getpf";

        let url = `tuner4tronic://${param1},${param2},${param3}`;
        if (this.isLoggedIn()) {
            url = `tuner4tronic://${param1},${param2},${param3},${this.getKey()}`;
        }

        window.location.href = url;
    }

    isLoggedIn() {
        return (
            this.getKey() !== undefined &&
            this.getKey() !== null &&
            this.getKey() !== ""
        );
    }

    getKey() {
        return localStorage.getItem(X_API_KEY);
    }

    openP4() {
        if (!this.isLoggedIn()) {
            this.openInP4Url();

            return;
        }

        this.setState({openInP4Modal: this.props.driver});
    }

    onTick() {
        this.setState({
            label: "",
            class: "saved-label",
        });
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps, prevState) {
        // Utilizzo tipico (non dimenticarti di comparare le props):
        if (this.state.queue !== prevState.queue) {
            clearInterval(this.interval);

            if (this.state.queue === null || this.state.queue.length === 0) {
                this.setState({
                    label: this.props.t("Project_saved"),
                    class: "saved-label",
                    disabled_download: false,
                });

                this.interval = setInterval(this.onTick, 2000);
            } else {
                let propsToUpdate = 0;

                const project = this.state.queue[this.props.project.id];
                if (project) {
                    const driver = project[this.props.driver.driverId];
                    if (driver) {
                        propsToUpdate = Object.keys(driver).length;
                    }
                }

                this.setState({
                    label: `${propsToUpdate} ${this.props.t("Properties_to_update")}`,
                    class: "not-saved-label",
                    disabled_download: true,
                });
            }
        }
    }

    onAddDriver() {
        this.props.handleAddDriver();
        this.props.allErrorsRemove();
    }

    render() {
        const driverUrl = "/projects/" + this.props.project.id + "/driver/";
        const summaryUrl = "/projects/" + this.props.project.id + "/summary";

        const errors = getErrorIssues(this.props.issues, {id: noProperty});
        const warnings = getWarningIssues(this.props.issues, {id: noProperty});

        let issueComponent = null;
        if (errors && errors.length > 0) {
            const errorsItems = [];
            errors.forEach((error) => {
                if (error.name && errors.indexOf(error.name) === -1) {
                    errorsItems.push(error.name + ": " + error.description);
                }
            });

            if (errorsItems.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover">
                            <Trans i18nKey="Errors"/>
                        </Popover.Title>
                        <Popover.Content>{errorsItems.join(", ")}</Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <AlertTriangle style={{margin: "auto", color: "#dc3545"}}/>
                    </OverlayTrigger>
                );
            }
        }

        if (issueComponent === null && warnings && warnings.length > 0) {
            let warningsItems = [];
            warnings.forEach((warning) => {
                if (warning.name && warnings.indexOf(warning.name) === -1) {
                    warningsItems.push(warning.name + ": " + warning.description);
                }
            });

            if (warningsItems.length > 0) {
                const popover = (
                    <Popover id="popover-basic">
                        <Popover.Title as="h3" className="error-popover">
                            <Trans i18nKey="Warnings"/>
                        </Popover.Title>
                        <Popover.Content>{warningsItems.join(", ")}</Popover.Content>
                    </Popover>
                );

                issueComponent = (
                    <OverlayTrigger placement="right" trigger="click" overlay={popover}>
                        <AlertTriangle style={{margin: "auto", color: "#f0ad4e"}}/>
                    </OverlayTrigger>
                );
            }
        }

        const renderNavLinks = () => {
            const drivers = this.props.drivers;

            return Object.keys(drivers).map((item) => (
                <Nav.Item key={item} className="driver-tab">
                    <Nav.Link as={NavLink} to={driverUrl + drivers[item].driverId}>
                        <span>
                            <Trans i18nKey="Driver"/>
                        </span>
                        <span className="driver-tab-description">{drivers[item].basicCode}</span>
                    </Nav.Link>
                </Nav.Item>
            ));
        };

        const isWindows = (() => {
            if (navigator.userAgentData && navigator.userAgentData.platform) {
                return navigator.userAgentData.platform.toLowerCase().includes("windows");
            }

            // Fallback for older browsers
            return navigator.platform.toLowerCase().includes("win") || navigator.userAgent.toLowerCase().includes("windows");
        })();

        return (
            <Row className="project-header-container">
                <Col sm={4}>
                    <Nav
                        variant="tabs"
                        activeKey={this.state.selectedKey}
                        onSelect={(selectedKey) => this.setState({selectedKey: selectedKey})}
                    >
                        {renderNavLinks()}
                        <Nav.Item>
                            <Nav.Link onClick={() => this.onAddDriver()}>+</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link as={NavLink} to={summaryUrl}>
                                <Trans i18nKey="Summary"/>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col sm={2} className={this.state.class}>
                    {this.state.label}
                </Col>
                <Col sm={3} style={{margin: "0", display: "flex", alignItems: "center"}}>
                    {/* <Form.Group controlId="name" style={{ margin: '0', display: "flex"}}> */}
                    {/* <Form.Label className="required" style={{ fontWeight: "700", whiteSpace: "nowrap", marginTop: "0.4rem" }}>Project Name</Form.Label> */}
                    <div style={{fontWeight: "bold", whiteSpace: "nowrap"}}>
                        <Trans i18nKey="Project_Name"/>
                        :&nbsp;
                    </div>
                    <OverlayTrigger
                        rootClose
                        placement="left"
                        overlay={(props) => <Tooltip {...props}>{this.props.projectName}</Tooltip>}
                    >
                        {/* <Form.Control
                                required
                                disabled
                                name="projectName"
                                type="text"
                                style={{ marginTop: "0.2rem", width: "100%" }}
                                value={this.props.projectName}
                                onChange={this.props.handleChangeProjectInfo}
                                placeholder="Project name"
                                isdanger={'' + (!this.props.projectName || this.props.projectName.trim() === '')}
                            /> */}
                        <div>{this.props.projectName}</div>
                    </OverlayTrigger>
                    {/* </Form.Group> */}
                </Col>
                <Col sm={3} className="end">
                    {issueComponent}
                    {isWindows && (
                        <Button
                            variant="outline-primary"
                            disabled={this.props.disabled}
                            className="edit-icon-project-header"
                            onClick={this.openP4}
                        >
                            <Trans i18nKey="Open_in_P4"/>
                        </Button>
                    )}
                    <Button
                        variant="secondary"
                        disabled={this.props.disabled}
                        className="edit-icon-project-header"
                        onClick={(e) => this.props.copyProject(e)}
                    >
                        {this.props.copyProjectButtonText}
                    </Button>
                    <Button
                        variant="primary"
                        disabled={this.props.disabled || this.state.disabled_download}
                        className="edit-icon-project-header"
                        onClick={(e) => this.props.saveProject(e)}
                    >
                        {this.props.saveProjectButtonText}
                    </Button>
                    {/* <Close className="close-icon-project-header" onClick={(e) => this.closeProject()} /> */}
                </Col>

                {/* Modal P4 */}
                <Modal
                    show={this.state.openInP4Modal !== null}
                    onHide={() => this.setState({openInP4Modal: null})}
                    animation={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title style={{color: "#E95B0D"}}>
                            <Trans i18nKey="Warning"/>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p style={{color: "rgb(255, 0, 0)"}}>
                            {" "}
                            <b>
                                <Trans i18nKey="Public_Mode_Project_Deleted"/>
                            </b>
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" style={{marginRight: "0"}} onClick={this.openInP4Url}>
                            {<Trans i18nKey="Continue_anyways"/>}
                        </Button>
                        {/* <Button variant="secondary" onClick={() => this.setState({ openInP4Modal: null })}>
              {<Trans i18nKey="No" />}
            </Button> */}
                    </Modal.Footer>
                </Modal>
            </Row>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        project: state.project.info,
        projectIstemporary: state.project.isTemporary,
        issues: state.project.issueByProperty,
        drivers: state.drivers,
    };
};

const mapDispatchToProps = {
    updateDriverProperties,
    fetchDriverProperties,
    allErrorsRemove,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProjectHeader)));
